export const EventRegistrationApiEndpoints = {
  CREATE_REGISTRATION_OPTION:
    "/registration-setting-event-option/registration-setting",
  DELETE_REGISTRATION_OPTION:
    "/registration-setting-event-option/registration-setting",
  UPDATE_REGISTRATION_OPTION:
    "/registration-setting-event-option/registration-setting",
  FETCH_REGISTRATION_OPTIONS:
    "/registration-setting-event-option/registration-setting",
  FETCH_REGISTRATION_OPTION_EVENTS:
    "/registration-setting-event-option/registration-setting"
};
